var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WasmLoader } from '@seddi/core';
import { RecolorModule } from '@seddi/ui-recolor';
import { SceneGeometryModule } from '@seddi/ui-three-viewer';
import WaGarmentsGeometry from '@seddi/wa-garments-geometry';
import WaRender from '@seddi/wa-render';
import log from 'loglevel';
import { retry } from './core/retry';
import { store } from './store/appStore';
import WaGarmentsGeometryWasm from '@seddi/wa-garments-geometry/lib/index.wasm';
import WaRenderWasm from '@seddi/wa-render/lib/index.wasm';
let sceneGeometryModule = null;
/**
 * Init app.
 */
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    log.info('App is initializing');
    // fetch and instantiate Web Assembly modules
    yield Promise.all([
        fetch(WaGarmentsGeometryWasm)
            .then(res => res.arrayBuffer())
            .then(arr => WasmLoader.Load(WaGarmentsGeometry, new Uint8Array(arr))),
        fetch(WaRenderWasm)
            .then(res => res.arrayBuffer())
            .then(arr => WasmLoader.Load(WaRender, new Uint8Array(arr))),
        RecolorModule.init(),
    ]);
    // TODO: hide @seddi/ui-three-viewer SceneGeometryModule life-cycle management
    sceneGeometryModule = new SceneGeometryModule();
    // log ready
    log.info('App is ready');
});
/**
 * Wait for app initialization.
 */
export const waitForAppReady = (() => {
    let promise = null;
    return () => {
        if (promise === null) {
            promise = init();
        }
        return promise;
    };
})();
/**
 * Wait for viewer available in the hierarchy.
 * @param interval Retry interval in milliseconds.
 * @param numRetries Retry max count.
 */
const waitForViewer = (interval = 100, numRetries = 50) => {
    return retry(() => {
        const viewerRef = store.getState().appRefs.viewerRef;
        if (viewerRef === null || viewerRef === void 0 ? void 0 : viewerRef.current) {
            return viewerRef.current;
        }
        throw Error('Viewer not found');
    }, interval, numRetries);
};
/**
 * Wait for all scene resources ready promise.
 */
const waitForSceneReadyPromise = () => __awaiter(void 0, void 0, void 0, function* () {
    // wait for viewer
    const viewer = yield waitForViewer();
    if (!viewer) {
        log.warn('Viewer not found');
        return;
    }
    // check scene resources already loaded
    {
        const resources = viewer.resources;
        if (resources.itemsLoaded === resources.itemsTotal) {
            return;
        }
    }
    // track progress with resources progress events
    return new Promise(resolve => {
        function handleResourcesProgress(event) {
            const progressEvent = event;
            if (progressEvent.loaded < progressEvent.total) {
                // some resources loading
                return;
            }
            // all resources loaded
            viewer.removeEventListener('resourcesprogress', handleResourcesProgress);
            log.info('Scene is ready');
            resolve();
        }
        viewer.addEventListener('resourcesprogress', handleResourcesProgress);
    });
});
/**
 * Wait for all scene resources ready.
 */
export const waitForSceneReady = (() => {
    // single promise at once
    let promise = null;
    return () => {
        if (promise === null) {
            promise = waitForSceneReadyPromise();
            promise.then(() => {
                setTimeout(() => {
                    // remove current promise
                    promise = null;
                });
            });
        }
        return promise;
    };
})();
/**
 * Dispose app.
 */
export const dispose = () => {
    sceneGeometryModule === null || sceneGeometryModule === void 0 ? void 0 : sceneGeometryModule.geometryCache.dispose();
    return Promise.all([RecolorModule.dispose()]).then(() => {
        return;
    });
};
